import React from 'react';

export interface CitrixWorkspaceIconProps {
	className?: string;
	width?: number;
	height?: number;
}

export const CitrixWorkspaceIcon: React.FC<CitrixWorkspaceIconProps> = ({
	className,
	width = 20,
	height = 20,
}) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 150 150"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<circle cx="75" cy="75" r="75" fill="#2071C5" />
			<g clipPath="url(#clip0_9818_29335)">
				<path
					d="M74.9231 81.9919C78.8429 82.0079 81.9349 78.9529 81.9577 75.043C81.9803 71.1618 78.8722 68.0061 75.0049 67.9816C71.1432 67.9575 67.9899 71.0858 67.9719 74.961C67.954 78.8756 71.02 81.9761 74.9231 81.9919L74.9203 82.6895L74.9231 81.9919ZM74.9621 108.281C56.6951 108.226 41.81 93.3973 41.7421 75.1696C41.6747 56.9207 56.3961 41.8918 74.4777 41.7574C79.0919 41.7236 82.3752 45.3955 81.5394 49.7139C80.9147 52.9436 78.2585 55.0319 74.7032 55.1302C65.8081 55.376 58.2496 61.0848 55.936 69.3758C53.6989 77.3931 55.6732 84.3544 61.7888 89.8081C67.9614 95.3124 75.1623 96.5011 82.7268 93.2472C90.3756 89.9571 94.4421 83.8505 94.8322 75.2747C94.9672 72.307 96.175 70.1991 98.6348 69.0121C100.993 67.8743 103.388 68.1121 105.519 69.6841C107.237 70.9516 108.136 72.7395 108.185 74.922C108.561 91.4575 95.0948 106.512 78.5771 108.023C77.9087 108.084 77.3467 108.125 76.1933 108.2C75.5727 108.24 75.3237 108.257 75.0135 108.279L74.9642 107.583L74.9621 108.281ZM14.9992 74.9091C15.1244 41.9957 41.7518 15.1439 74.4135 14.9998C78.5457 14.9817 81.5986 17.7616 81.6126 21.6123C81.6267 25.4792 78.6589 28.2415 74.4955 28.2963C49.4563 28.6256 29.5529 48.0621 28.2474 73.4692C27.0274 97.2085 45.3587 118.554 69.4672 121.453C96.946 124.756 121.229 103.437 121.707 75.5844C121.788 70.885 125.223 67.7247 129.491 68.506C132.795 69.1112 134.961 71.8965 134.929 75.4549C134.697 100.768 118.701 123.134 94.7917 131.576C55.9659 145.286 14.8439 116.082 14.9992 74.9091L15.6973 74.9117L14.9992 74.9091Z"
					fill="white"
				/>
			</g>
			<defs>
				<clipPath id="clip0_9818_29335">
					<rect width="120" height="120" fill="white" transform="translate(15 15)" />
				</clipPath>
			</defs>
		</svg>
	);
};
